import { render, staticRenderFns } from "./ProgramReportsAdminSuper.vue?vue&type=template&id=403a74a4&scoped=true&lang=pug&"
import script from "./ProgramReportsAdminSuper.vue?vue&type=script&lang=js&"
export * from "./ProgramReportsAdminSuper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403a74a4",
  null
  
)

export default component.exports